export default [
  "01m",
  "01r",
  "02m",
  "02r",
  "03m",
  "03r",
  "04m",
  "05m",
  "06m",
  "07m",
  "09m",
  "0ag",
  "0mg",
  "0rs",
  "10m",
  "11m",
  "12m",
  "13m",
] as const;
